import styled from 'styled-components';

export const LoginStyles = styled.div`
    padding-top:150px ;
    padding-bottom:150px ;

`;

export const LoginCard = styled.div`
    width: 600px;
    padding: 30px;

   .error-text{
    color: red;
    font-size: 12px;
   }

   .valid-text{
    border-color: red;
   }
   .form-control:focus {
    border-color: #00B759 !important;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 10px;
  }
`;
